<template>
  <div class="home_layout">
    <div class="home_body">
      <div class="detail-content-wrap">
        <div class="line"></div>
        <div class="coupon">
          <div class="dashed-line coupon-line"></div>
        </div>
        <div class="detail-content">
          <div class="discount-info">
            <img class="pic" :src="baseInfo.picUrl"/>
            <div class="discount-name">{{ baseInfo.goodsName }}</div>
            <div class="discount-amount">
							<span>{{ baseInfo.goodsPrice }}</span
              >元
            </div>
          </div>
          <div class="dashed-line"></div>
          <div class="card-info">
            <div>卡号：</div>
            <div class="info">
              <span class="code">{{ baseInfo.couponList[0].cordCode }}</span>
              <div class="copy-btn" @click="copy(baseInfo.couponList[0].cordCode)">复制</div>
            </div>
            <div>卡密：</div>
            <div class="info">
              <span class="code" v-html="formattedCordPass"></span>
              <div class="copy-btn" @click="copy(baseInfo.couponList[0].cordPass)">复制</div>
            </div>
          </div>
          <div class="dashed-line"></div>

          <div class="discription">
            <div class="section-title">使用说明</div>
            <p class="desc" v-html="contents"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import {handleRequestError} from '@/static/js/common'

export default {
  data() {
    return {
      baseInfo: {}
    }
  },

  mounted() {
    console.log('767', this.$route.params)
    let orderId = this.$route.params.orderId
    if (!orderId) {
      orderId = localStorage.getItem('orderId')
      console.log('orderId', orderId)
    }

    // 优先从路由参数中获取 orderDetailId，如果路由参数为空，则从 localStorage 中获取
    let orderDetailId = this.$route.params.orderDetailId || localStorage.getItem('goodsOrderId');

    // 如果 orderDetailId 存在，则将其存储到 localStorage 中
    if (orderDetailId) {
      localStorage.setItem('goodsOrderId', orderDetailId);
    }

    console.log('orderDetailId:', orderDetailId);

    let memberId = this.$route.params.memberId || localStorage.getItem('memberId')
    console.log('memberId', memberId)

    const seeFlag = this.$route.params.seeFlag
    let regionNo = this.$route.params.regionNo || localStorage.getItem('regionNo')
    console.log('regionNo', regionNo)


    let cardgoodsId = this.$route.params.cardgoodsId || localStorage.getItem('CardGoodsId');
    if (cardgoodsId) {

      localStorage.setItem('CardGoodsId', cardgoodsId);
    }
    console.log('CardGoodsId', cardgoodsId)

    let goodsName = this.$route.params.goodsName || localStorage.getItem('goodsName')
    if (goodsName) {
      localStorage.setItem('goodsName', goodsName)
    }
    console.log('goodsName', goodsName)

    let spn = localStorage.getItem('spn')
    const params = {
      orderId,
      orderDetailId,
      cardgoodsId,
      memberId,
      seeFlag,
      regionNo,
      goodsName,
      spn
    }
    console.log('params', params)
    this.getCouponDetail(params)
  },

  computed: {
    ...mapState(['loginInfo']),
    contents() {
      return this.baseInfo.info
    },
    formattedCordPass() {
      const maxLength = 20 // 设置每行最大字符数
      let formatted = this.baseInfo.couponList[0].cordPass

      // 如果卡密超过 maxLength，插入换行符
      if (formatted.length > maxLength) {
        // 这里通过正则来每15个字符插入一个换行符
        formatted = formatted.replace(/(.{20})/g, '$1\n')
      }

      return formatted
    }
  },
  filters: {},
  methods: {
    /** 获取详情 */
    getCouponDetail(params) {
      this.post(this.apis.findOrderDetail, params)
          .then((res) => {
            console.log('1112', res)
            if (res.data.code === '0') {
              const data = res.data.data
              console.log('data111', data)
              data.couponList = data.codes
              console.log('datainf', data.info)
              data.info = data.info.replace(/\n/g, '<br>')
              this.baseInfo = data
              console.log('2222', this.baseInfo)
            }
          })
          .catch((error) => {
            console.log(error)
            handleRequestError(this, error)
          })
    },
    copy(val) {
      try {
        //创建input标签
        var input = document.createElement('input')
        //将input的值设置为需要复制的内容
        input.value = val
        //添加input标签
        document.body.appendChild(input)
        //选中input标签
        input.select()
        //执行复制
        document.execCommand('copy')
        //成功提示信息
        this.$toast({
          message: '复制成功',
          duration: 1000
        })
        //移除input标签
        document.body.removeChild(input)
        // const originInput = document.querySelector("#couponCode");
        // originInput.select();
        // originInput.setSelectionRange(0, originInput.value.length); // chrome 不支持
        // if (document.execCommand("copy")) {
        //   document.execCommand("copy");
        //   this.$toast({
        //     message: "复制成功",
        //     duration: 1000,
        //   });
        // } else {
        //   this.$toast({
        //     message: "无法复制此文本",
        //     duration: 1000,
        //   });
        // }
      } catch (err) {
        console.log(err)
        navigator.clipboard
            .writeText(val)
            .then(() => {
              this.$toast({
                message: '复制成功',
                duration: 1000
              })
            })
            .catch((err) => {
              // 如果用户没有授权，则抛出异常
              this.$toast({
                message: '无法复制此文本',
                duration: 1000
              })
              console.error('无法复制此文本：', err)
            })
      }
    }
    // toCopy(val) {
    //   navigator.clipboard
    //     .writeText(val)
    //     .then(() => {
    //       this.$toast({
    //         message: "复制成功",
    //         duration: 1000,
    //       });
    //     })
    //     .catch((err) => {
    //       // 如果用户没有授权，则抛出异常
    //       this.$toast({
    //         message: "无法复制此文本",
    //         duration: 1000,
    //       });
    //       console.error("无法复制此文本：", err);
    //     });
    // },
  }
}
</script>
<style scoped lang="less">
.home_layout {
  width: 100%;
  height: 100vh;
  background-color: #f3f3f3;
}

.home_body {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.detail-content-wrap {
  padding: 16px 24px 50px 24px;
  position: relative;
  z-index: 1;

  &::before {
    content: '';
    background: #ffb260;
    height: 476px;
    width: 100%;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
  }

  .detail-content {
    background: #fff;
    margin: 0 10px;
    margin-top: -2px;
    position: relative;
    z-index: 1;

    .discount-info {
      text-align: center;
      padding-bottom: 50px;
      position: relative;
      z-index: 1;
      background: #fff;

      .pic {
        border-radius: 100%;
        width: 100px;
        height: 100px;
        border: 1px solid #d9d9d9;
        display: block;
        object-fit: cover;
        margin: 0 auto;
      }

      .discount-name {
        font-size: 40px;
        margin-top: 16px;
      }

      .discount-amount {
        color: #f96914;
        flex-shrink: 0;
        display: inline-flex;
        align-items: flex-end;
        justify-content: center;
        font-size: 28px;
        position: relative;
        margin-top: 24px;

        span {
          font-size: 80px;
          line-height: 1;
          font-weight: bold;
        }
      }
    }

    .discription {
      padding: 24px 50px;

      .desc {
        font-size: 24px;
        color: #919191;
        line-height: 36px;
      }
    }

    .section-title {
      font-size: 32px;
      margin-bottom: 18px;
      position: relative;
      display: flex;
      align-items: center;

      &::before {
        content: '';
        width: 6px;
        height: 28px;
        background: #fb7019;
        margin-right: 14px;
        display: block;
      }
    }
  }
}

.line {
  position: relative;
  z-index: 1;
  height: 4px;
  background: #d9d9d9;
  box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.25);
}

.dashed-line {
  height: 1px;
  background: repeating-linear-gradient(to right, #d3d3d3, #d3d3d3 6px, transparent 6px, transparent 12px);
}

.coupon {
  margin: 0 10px;
  overflow: hidden;
  padding-top: 80px;
  filter: drop-shadow(0 0 0 rgba(0, 0, 0, 0.1));
  position: relative;
  color: #fff;

  &::after {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background: #fff;
    z-index: -1;
    -webkit-mask: radial-gradient(circle at 20px 61%, transparent 20px, red 0) -20px;
  }

  .coupon-line {
    position: absolute;
    left: 25px;
    top: 48px;
    width: calc(100% - 50px);
  }
}

.card-info {
  padding: 26px 80px 26px 60px;

  .info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    font-size: 26px;

    .code {
      flex: 1;
      padding-right: 10px;
      font-size: 32px;
      font-weight: bold;
    }

    .copy-btn {
      flex-shrink: 0;
      width: 116px;
      height: 44px;
      line-height: 44px;
      text-align: center;
      background: #ffffff;
      border-radius: 28px;
      border: 1px solid #fb7019;
      color: #fb7019;
      font-size: 24px;
    }
  }
}
</style>
